/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ActiveSessionDTO,
  AutocompleteUsernamesParams,
  BlockUserRequest,
  GetLoginActivitySummaryParams,
  GetLoginAnalyticsParams,
  GetLoginAttemptsParams,
  LoginActivitySummaryDTO,
  LoginAnalyticsDTO,
  LoginAttemptDTO,
  LoginSecurityConfigDTO,
  UserBlockStatusDTO
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Unblock a user
 */
export const unblockUser = (
    userId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<UserBlockStatusDTO>(
      {url: `/api/admin/user-security/unblock-user/${userId}`, method: 'POST', signal
    },
      options);
    }
  


export const getUnblockUserMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unblockUser>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof unblockUser>>, TError,{userId: string}, TContext> => {

const mutationKey = ['unblockUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unblockUser>>, {userId: string}> = (props) => {
          const {userId} = props ?? {};

          return  unblockUser(userId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UnblockUserMutationResult = NonNullable<Awaited<ReturnType<typeof unblockUser>>>
    
    export type UnblockUserMutationError = unknown

    /**
 * @summary Unblock a user
 */
export const useUnblockUser = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unblockUser>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unblockUser>>,
        TError,
        {userId: string},
        TContext
      > => {

      const mutationOptions = getUnblockUserMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary Reset failed login attempts for a user
 */
export const resetFailedAttempts = (
    userId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<UserBlockStatusDTO>(
      {url: `/api/admin/user-security/reset-failed-attempts/${userId}`, method: 'POST', signal
    },
      options);
    }
  


export const getResetFailedAttemptsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetFailedAttempts>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof resetFailedAttempts>>, TError,{userId: string}, TContext> => {

const mutationKey = ['resetFailedAttempts'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetFailedAttempts>>, {userId: string}> = (props) => {
          const {userId} = props ?? {};

          return  resetFailedAttempts(userId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ResetFailedAttemptsMutationResult = NonNullable<Awaited<ReturnType<typeof resetFailedAttempts>>>
    
    export type ResetFailedAttemptsMutationError = unknown

    /**
 * @summary Reset failed login attempts for a user
 */
export const useResetFailedAttempts = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetFailedAttempts>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetFailedAttempts>>,
        TError,
        {userId: string},
        TContext
      > => {

      const mutationOptions = getResetFailedAttemptsMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary Block a user (admin action)
 */
export const blockUser = (
    blockUserRequest: BlockUserRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<UserBlockStatusDTO>(
      {url: `/api/admin/user-security/block-user`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: blockUserRequest, signal
    },
      options);
    }
  


export const getBlockUserMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof blockUser>>, TError,{data: BlockUserRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof blockUser>>, TError,{data: BlockUserRequest}, TContext> => {

const mutationKey = ['blockUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof blockUser>>, {data: BlockUserRequest}> = (props) => {
          const {data} = props ?? {};

          return  blockUser(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BlockUserMutationResult = NonNullable<Awaited<ReturnType<typeof blockUser>>>
    export type BlockUserMutationBody = BlockUserRequest
    export type BlockUserMutationError = unknown

    /**
 * @summary Block a user (admin action)
 */
export const useBlockUser = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof blockUser>>, TError,{data: BlockUserRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof blockUser>>,
        TError,
        {data: BlockUserRequest},
        TContext
      > => {

      const mutationOptions = getBlockUserMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary Autocomplete usernames for search
 */
export const autocompleteUsernames = (
    params: AutocompleteUsernamesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<string[]>(
      {url: `/api/admin/user-security/usernames/autocomplete`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getAutocompleteUsernamesQueryKey = (params?: AutocompleteUsernamesParams,) => {
    return [`/api/admin/user-security/usernames/autocomplete`, ...(params ? [params]: [])] as const;
    }

    
export const getAutocompleteUsernamesQueryOptions = <TData = Awaited<ReturnType<typeof autocompleteUsernames>>, TError = unknown>(params: AutocompleteUsernamesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof autocompleteUsernames>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAutocompleteUsernamesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof autocompleteUsernames>>> = ({ signal }) => autocompleteUsernames(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof autocompleteUsernames>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type AutocompleteUsernamesQueryResult = NonNullable<Awaited<ReturnType<typeof autocompleteUsernames>>>
export type AutocompleteUsernamesQueryError = unknown


export function useAutocompleteUsernames<TData = Awaited<ReturnType<typeof autocompleteUsernames>>, TError = unknown>(
 params: AutocompleteUsernamesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof autocompleteUsernames>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof autocompleteUsernames>>,
          TError,
          Awaited<ReturnType<typeof autocompleteUsernames>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useAutocompleteUsernames<TData = Awaited<ReturnType<typeof autocompleteUsernames>>, TError = unknown>(
 params: AutocompleteUsernamesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof autocompleteUsernames>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof autocompleteUsernames>>,
          TError,
          Awaited<ReturnType<typeof autocompleteUsernames>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useAutocompleteUsernames<TData = Awaited<ReturnType<typeof autocompleteUsernames>>, TError = unknown>(
 params: AutocompleteUsernamesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof autocompleteUsernames>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Autocomplete usernames for search
 */

export function useAutocompleteUsernames<TData = Awaited<ReturnType<typeof autocompleteUsernames>>, TError = unknown>(
 params: AutocompleteUsernamesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof autocompleteUsernames>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getAutocompleteUsernamesQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get login attempts for a user
 */
export const getLoginAttempts = (
    username: string,
    params?: GetLoginAttemptsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LoginAttemptDTO[]>(
      {url: `/api/admin/user-security/login-attempts/${username}`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetLoginAttemptsQueryKey = (username?: string,
    params?: GetLoginAttemptsParams,) => {
    return [`/api/admin/user-security/login-attempts/${username}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetLoginAttemptsQueryOptions = <TData = Awaited<ReturnType<typeof getLoginAttempts>>, TError = unknown>(username: string,
    params?: GetLoginAttemptsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoginAttempts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoginAttemptsQueryKey(username,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoginAttempts>>> = ({ signal }) => getLoginAttempts(username,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(username), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLoginAttempts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLoginAttemptsQueryResult = NonNullable<Awaited<ReturnType<typeof getLoginAttempts>>>
export type GetLoginAttemptsQueryError = unknown


export function useGetLoginAttempts<TData = Awaited<ReturnType<typeof getLoginAttempts>>, TError = unknown>(
 username: string,
    params: undefined |  GetLoginAttemptsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoginAttempts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoginAttempts>>,
          TError,
          Awaited<ReturnType<typeof getLoginAttempts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoginAttempts<TData = Awaited<ReturnType<typeof getLoginAttempts>>, TError = unknown>(
 username: string,
    params?: GetLoginAttemptsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoginAttempts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoginAttempts>>,
          TError,
          Awaited<ReturnType<typeof getLoginAttempts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoginAttempts<TData = Awaited<ReturnType<typeof getLoginAttempts>>, TError = unknown>(
 username: string,
    params?: GetLoginAttemptsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoginAttempts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get login attempts for a user
 */

export function useGetLoginAttempts<TData = Awaited<ReturnType<typeof getLoginAttempts>>, TError = unknown>(
 username: string,
    params?: GetLoginAttemptsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoginAttempts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLoginAttemptsQueryOptions(username,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get login activity summary
 */
export const getLoginActivitySummary = (
    params?: GetLoginActivitySummaryParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LoginActivitySummaryDTO>(
      {url: `/api/admin/user-security/login-activity/summary`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetLoginActivitySummaryQueryKey = (params?: GetLoginActivitySummaryParams,) => {
    return [`/api/admin/user-security/login-activity/summary`, ...(params ? [params]: [])] as const;
    }

    
export const getGetLoginActivitySummaryQueryOptions = <TData = Awaited<ReturnType<typeof getLoginActivitySummary>>, TError = unknown>(params?: GetLoginActivitySummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoginActivitySummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoginActivitySummaryQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoginActivitySummary>>> = ({ signal }) => getLoginActivitySummary(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLoginActivitySummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLoginActivitySummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getLoginActivitySummary>>>
export type GetLoginActivitySummaryQueryError = unknown


export function useGetLoginActivitySummary<TData = Awaited<ReturnType<typeof getLoginActivitySummary>>, TError = unknown>(
 params: undefined |  GetLoginActivitySummaryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoginActivitySummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoginActivitySummary>>,
          TError,
          Awaited<ReturnType<typeof getLoginActivitySummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoginActivitySummary<TData = Awaited<ReturnType<typeof getLoginActivitySummary>>, TError = unknown>(
 params?: GetLoginActivitySummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoginActivitySummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoginActivitySummary>>,
          TError,
          Awaited<ReturnType<typeof getLoginActivitySummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoginActivitySummary<TData = Awaited<ReturnType<typeof getLoginActivitySummary>>, TError = unknown>(
 params?: GetLoginActivitySummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoginActivitySummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get login activity summary
 */

export function useGetLoginActivitySummary<TData = Awaited<ReturnType<typeof getLoginActivitySummary>>, TError = unknown>(
 params?: GetLoginActivitySummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoginActivitySummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLoginActivitySummaryQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get failed login attempts count for a user
 */
export const getFailedAttemptsCount = (
    username: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/api/admin/user-security/failed-attempts/${username}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetFailedAttemptsCountQueryKey = (username?: string,) => {
    return [`/api/admin/user-security/failed-attempts/${username}`] as const;
    }

    
export const getGetFailedAttemptsCountQueryOptions = <TData = Awaited<ReturnType<typeof getFailedAttemptsCount>>, TError = unknown>(username: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFailedAttemptsCount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFailedAttemptsCountQueryKey(username);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFailedAttemptsCount>>> = ({ signal }) => getFailedAttemptsCount(username, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(username), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFailedAttemptsCount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetFailedAttemptsCountQueryResult = NonNullable<Awaited<ReturnType<typeof getFailedAttemptsCount>>>
export type GetFailedAttemptsCountQueryError = unknown


export function useGetFailedAttemptsCount<TData = Awaited<ReturnType<typeof getFailedAttemptsCount>>, TError = unknown>(
 username: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFailedAttemptsCount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFailedAttemptsCount>>,
          TError,
          Awaited<ReturnType<typeof getFailedAttemptsCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFailedAttemptsCount<TData = Awaited<ReturnType<typeof getFailedAttemptsCount>>, TError = unknown>(
 username: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFailedAttemptsCount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFailedAttemptsCount>>,
          TError,
          Awaited<ReturnType<typeof getFailedAttemptsCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFailedAttemptsCount<TData = Awaited<ReturnType<typeof getFailedAttemptsCount>>, TError = unknown>(
 username: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFailedAttemptsCount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get failed login attempts count for a user
 */

export function useGetFailedAttemptsCount<TData = Awaited<ReturnType<typeof getFailedAttemptsCount>>, TError = unknown>(
 username: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFailedAttemptsCount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetFailedAttemptsCountQueryOptions(username,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get current security configuration
 */
export const getSecurityConfig = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LoginSecurityConfigDTO>(
      {url: `/api/admin/user-security/config`, method: 'GET', signal
    },
      options);
    }
  

export const getGetSecurityConfigQueryKey = () => {
    return [`/api/admin/user-security/config`] as const;
    }

    
export const getGetSecurityConfigQueryOptions = <TData = Awaited<ReturnType<typeof getSecurityConfig>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSecurityConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSecurityConfigQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSecurityConfig>>> = ({ signal }) => getSecurityConfig(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSecurityConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetSecurityConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getSecurityConfig>>>
export type GetSecurityConfigQueryError = unknown


export function useGetSecurityConfig<TData = Awaited<ReturnType<typeof getSecurityConfig>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSecurityConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSecurityConfig>>,
          TError,
          Awaited<ReturnType<typeof getSecurityConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSecurityConfig<TData = Awaited<ReturnType<typeof getSecurityConfig>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSecurityConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSecurityConfig>>,
          TError,
          Awaited<ReturnType<typeof getSecurityConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSecurityConfig<TData = Awaited<ReturnType<typeof getSecurityConfig>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSecurityConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get current security configuration
 */

export function useGetSecurityConfig<TData = Awaited<ReturnType<typeof getSecurityConfig>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSecurityConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetSecurityConfigQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get all blocked users
 */
export const getBlockedUsers = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<UserBlockStatusDTO[]>(
      {url: `/api/admin/user-security/blocked-users`, method: 'GET', signal
    },
      options);
    }
  

export const getGetBlockedUsersQueryKey = () => {
    return [`/api/admin/user-security/blocked-users`] as const;
    }

    
export const getGetBlockedUsersQueryOptions = <TData = Awaited<ReturnType<typeof getBlockedUsers>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBlockedUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBlockedUsersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBlockedUsers>>> = ({ signal }) => getBlockedUsers(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBlockedUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetBlockedUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getBlockedUsers>>>
export type GetBlockedUsersQueryError = unknown


export function useGetBlockedUsers<TData = Awaited<ReturnType<typeof getBlockedUsers>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBlockedUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBlockedUsers>>,
          TError,
          Awaited<ReturnType<typeof getBlockedUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBlockedUsers<TData = Awaited<ReturnType<typeof getBlockedUsers>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBlockedUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBlockedUsers>>,
          TError,
          Awaited<ReturnType<typeof getBlockedUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBlockedUsers<TData = Awaited<ReturnType<typeof getBlockedUsers>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBlockedUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get all blocked users
 */

export function useGetBlockedUsers<TData = Awaited<ReturnType<typeof getBlockedUsers>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBlockedUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetBlockedUsersQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get block status for a specific user
 */
export const getBlockStatus = (
    userId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<UserBlockStatusDTO>(
      {url: `/api/admin/user-security/block-status/${userId}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetBlockStatusQueryKey = (userId?: string,) => {
    return [`/api/admin/user-security/block-status/${userId}`] as const;
    }

    
export const getGetBlockStatusQueryOptions = <TData = Awaited<ReturnType<typeof getBlockStatus>>, TError = unknown>(userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBlockStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBlockStatusQueryKey(userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBlockStatus>>> = ({ signal }) => getBlockStatus(userId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBlockStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetBlockStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getBlockStatus>>>
export type GetBlockStatusQueryError = unknown


export function useGetBlockStatus<TData = Awaited<ReturnType<typeof getBlockStatus>>, TError = unknown>(
 userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBlockStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBlockStatus>>,
          TError,
          Awaited<ReturnType<typeof getBlockStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBlockStatus<TData = Awaited<ReturnType<typeof getBlockStatus>>, TError = unknown>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBlockStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBlockStatus>>,
          TError,
          Awaited<ReturnType<typeof getBlockStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBlockStatus<TData = Awaited<ReturnType<typeof getBlockStatus>>, TError = unknown>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBlockStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get block status for a specific user
 */

export function useGetBlockStatus<TData = Awaited<ReturnType<typeof getBlockStatus>>, TError = unknown>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBlockStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetBlockStatusQueryOptions(userId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get detailed login analytics for graphs and reports
 */
export const getLoginAnalytics = (
    params?: GetLoginAnalyticsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LoginAnalyticsDTO>(
      {url: `/api/admin/user-security/analytics`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetLoginAnalyticsQueryKey = (params?: GetLoginAnalyticsParams,) => {
    return [`/api/admin/user-security/analytics`, ...(params ? [params]: [])] as const;
    }

    
export const getGetLoginAnalyticsQueryOptions = <TData = Awaited<ReturnType<typeof getLoginAnalytics>>, TError = unknown>(params?: GetLoginAnalyticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoginAnalytics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoginAnalyticsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoginAnalytics>>> = ({ signal }) => getLoginAnalytics(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLoginAnalytics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLoginAnalyticsQueryResult = NonNullable<Awaited<ReturnType<typeof getLoginAnalytics>>>
export type GetLoginAnalyticsQueryError = unknown


export function useGetLoginAnalytics<TData = Awaited<ReturnType<typeof getLoginAnalytics>>, TError = unknown>(
 params: undefined |  GetLoginAnalyticsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoginAnalytics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoginAnalytics>>,
          TError,
          Awaited<ReturnType<typeof getLoginAnalytics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoginAnalytics<TData = Awaited<ReturnType<typeof getLoginAnalytics>>, TError = unknown>(
 params?: GetLoginAnalyticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoginAnalytics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoginAnalytics>>,
          TError,
          Awaited<ReturnType<typeof getLoginAnalytics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoginAnalytics<TData = Awaited<ReturnType<typeof getLoginAnalytics>>, TError = unknown>(
 params?: GetLoginAnalyticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoginAnalytics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get detailed login analytics for graphs and reports
 */

export function useGetLoginAnalytics<TData = Awaited<ReturnType<typeof getLoginAnalytics>>, TError = unknown>(
 params?: GetLoginAnalyticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoginAnalytics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLoginAnalyticsQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get active user sessions
 */
export const getActiveSessions = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ActiveSessionDTO[]>(
      {url: `/api/admin/user-security/active-sessions`, method: 'GET', signal
    },
      options);
    }
  

export const getGetActiveSessionsQueryKey = () => {
    return [`/api/admin/user-security/active-sessions`] as const;
    }

    
export const getGetActiveSessionsQueryOptions = <TData = Awaited<ReturnType<typeof getActiveSessions>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveSessions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActiveSessionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActiveSessions>>> = ({ signal }) => getActiveSessions(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getActiveSessions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetActiveSessionsQueryResult = NonNullable<Awaited<ReturnType<typeof getActiveSessions>>>
export type GetActiveSessionsQueryError = unknown


export function useGetActiveSessions<TData = Awaited<ReturnType<typeof getActiveSessions>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveSessions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActiveSessions>>,
          TError,
          Awaited<ReturnType<typeof getActiveSessions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetActiveSessions<TData = Awaited<ReturnType<typeof getActiveSessions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveSessions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActiveSessions>>,
          TError,
          Awaited<ReturnType<typeof getActiveSessions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetActiveSessions<TData = Awaited<ReturnType<typeof getActiveSessions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveSessions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get active user sessions
 */

export function useGetActiveSessions<TData = Awaited<ReturnType<typeof getActiveSessions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveSessions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetActiveSessionsQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



